import { render, staticRenderFns } from "./AccountsAddressInformationForm.vue?vue&type=template&id=1bb95a52&scoped=true&"
import script from "./AccountsAddressInformationForm.vue?vue&type=script&lang=js&"
export * from "./AccountsAddressInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb95a52",
  null
  
)

export default component.exports